import { render, staticRenderFns } from "./FavoriteAccounts.vue?vue&type=template&id=d83178f4&"
import script from "./FavoriteAccounts.vue?vue&type=script&lang=js&"
export * from "./FavoriteAccounts.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteAccounts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports